import Model from '@models/model';

export const PURCHASE_REQUEST_STATUS_DRAFT = 'Draft';
export const PURCHASE_REQUEST_STATUS_CLOSED = 'Closed';

export default class PurchaseRequest extends Model {
    resource() {
        return 'purchase-requests';
    }

    getGlCodeId() {
        if (this.job_id) {
            return this.job.gl_code_id;
        }
        if (this.department_id) {
            return this.purchase_request_category.gl_code_id;
        }

        return null;
    }
}
